import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface OutdoorStructuresDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const OutdoorStructuresDescription: React.FC<OutdoorStructuresDescriptionProps> = ({
    required,
    readOnly,
    propertyGuid,
    isReview = false,
}) => {
    const [outdoorStructures, set_outdoorStructures] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Final Structure']?.['Outdoor Structures']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Final Structure': { ...b.values?.['Final Structure'], 'Outdoor Structures': [v, b.values?.['Final Structure']?.['Outdoor Structures']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={outdoorStructures}
                />
            ) : (
                <TextBox
                    value={outdoorStructures}
                    onChange={(value) => set_outdoorStructures(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
